{
  "v": "5.7.4",
  "fr": 15,
  "ip": 0,
  "op": 72,
  "w": 160,
  "h": 107,
  "nm": "logo_only",
  "ddd": 1,
  "assets": [],
  "layers": [
    {
      "ddd": 1,
      "ind": 2,
      "ty": 4,
      "nm": "LOGO_02 Outlines",
      "parent": 5,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "rx": { "a": 0, "k": 0, "ix": 8 },
        "ry": { "a": 0, "k": 720, "ix": 9 },
        "rz": { "a": 0, "k": 0, "ix": 10 },
        "or": { "a": 0, "k": [0, 0, 0], "ix": 7 },
        "p": { "a": 0, "k": [375, 667, 0], "ix": 2 },
        "a": { "a": 0, "k": [375, 667, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-0.601, -0.431],
                    [-2.249, -1.224],
                    [0, 0],
                    [-3.205, -2.377],
                    [-4.114, 0.086],
                    [-1.921, 0.718],
                    [-1.55, 1.313],
                    [-0.857, 3.496],
                    [0, 0],
                    [0, 0],
                    [-2.194, 1.537],
                    [-0.793, 0.634],
                    [0, 0],
                    [-1.19, 1.341],
                    [-1.086, 3.549],
                    [1.199, 3.52],
                    [0.097, 0.259],
                    [0, 0],
                    [0.427, 0.674],
                    [1.169, 1.369],
                    [3.564, 1.342],
                    [3.43, -0.981],
                    [1.582, -0.749],
                    [1.103, -0.648],
                    [0, 0],
                    [0.566, -0.439],
                    [0.731, -0.491],
                    [0.627, 0.288],
                    [1.081, 1.116],
                    [0, 0],
                    [1.222, 0.575],
                    [1.755, 0.445],
                    [3.565, -1.263],
                    [2.412, -2.689],
                    [0.991, -1.523],
                    [0.385, -0.755],
                    [0, 0],
                    [0.128, -0.381],
                    [-1.076, -3.575],
                    [-2.31, -2.72],
                    [-1.608, -1.38]
                  ],
                  "o": [
                    [0.583, 0.458],
                    [2.089, 1.497],
                    [0, 0],
                    [1.901, 4.147],
                    [3.262, 2.5],
                    [2.056, -0.085],
                    [1.919, -0.724],
                    [2.874, -2.357],
                    [0, 0],
                    [0, 0],
                    [2.371, -1.232],
                    [0.828, -0.581],
                    [0, 0],
                    [1.331, -1.167],
                    [2.314, -2.667],
                    [1.104, -3.528],
                    [-0.086, -0.264],
                    [0, 0],
                    [-0.361, -0.721],
                    [-0.975, -1.521],
                    [-2.302, -2.702],
                    [-3.543, -1.389],
                    [-1.737, 0.463],
                    [-1.171, 0.552],
                    [0, 0],
                    [-0.538, 0.482],
                    [-0.703, 0.535],
                    [-0.636, 0.27],
                    [-1.204, -0.949],
                    [0, 0],
                    [-1.138, -0.7],
                    [-1.599, -0.756],
                    [-3.484, -0.91],
                    [-3.588, 1.211],
                    [-1.225, 1.352],
                    [-0.451, 0.706],
                    [0, 0],
                    [-0.15, 0.371],
                    [-1.251, 3.542],
                    [1.059, 3.6],
                    [1.409, 1.624],
                    [0, 0]
                  ],
                  "v": [
                    [-28.72, 10.366],
                    [-26.951, 11.708],
                    [-18.491, 16.454],
                    [-17.281, 19.91],
                    [-10.602, 29.08],
                    [0.926, 32.739],
                    [6.945, 31.544],
                    [12.194, 28.44],
                    [17.91, 19.275],
                    [18.9, 16.425],
                    [20.069, 15.872],
                    [26.887, 11.697],
                    [29.312, 9.869],
                    [30.956, 8.506],
                    [34.745, 4.749],
                    [40.172, -4.546],
                    [40.052, -15.564],
                    [39.766, -16.344],
                    [38.861, -18.427],
                    [37.681, -20.524],
                    [34.535, -24.832],
                    [25.836, -31.416],
                    [14.897, -31.718],
                    [9.93, -29.842],
                    [6.53, -28.024],
                    [4.918, -26.949],
                    [3.258, -25.57],
                    [1.109, -24.03],
                    [-0.901, -24.066],
                    [-4.354, -27.127],
                    [-5.742, -28.06],
                    [-9.27, -29.995],
                    [-14.296, -31.85],
                    [-25.247, -31.562],
                    [-34.267, -25.279],
                    [-37.538, -20.967],
                    [-38.794, -18.772],
                    [-39.553, -17.11],
                    [-39.977, -15.984],
                    [-40.199, -4.854],
                    [-34.815, 4.599],
                    [-30.264, 9.085]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-0.947, 0.343],
                    [-1.577, 0.323],
                    [-1.542, -0.083],
                    [-1.402, -0.587],
                    [-2.074, -2.469],
                    [-0.866, -1.343],
                    [-0.427, -0.986],
                    [0, 0],
                    [0.792, -2.736],
                    [2.066, -2.526],
                    [0.697, -0.733],
                    [0, 0],
                    [1.263, -1.025],
                    [2.836, -1.635],
                    [0, 0],
                    [2.528, -1.782],
                    [3.384, -0.06],
                    [2.831, 1.91],
                    [1.418, 3.069],
                    [0, 0],
                    [3.382, 3.219],
                    [0, 0],
                    [0.816, 1.007],
                    [0.833, 3.032],
                    [-0.902, 2.82],
                    [0, 0],
                    [-0.614, 0.958],
                    [-1.053, 1.222],
                    [-2.911, 1.129],
                    [-1.575, 0.13],
                    [-1.607, -0.267],
                    [-1.577, -0.554],
                    [-1.021, -0.449],
                    [0, 0],
                    [-1.352, -0.944],
                    [0, 0],
                    [0, 0],
                    [-0.845, 0.32],
                    [0, 0],
                    [0, 0],
                    [-0.79, 0.424],
                    [-0.807, 0.329]
                  ],
                  "o": [
                    [0.936, -0.399],
                    [1.561, -0.56],
                    [1.579, -0.317],
                    [1.541, 0.1],
                    [2.813, 1.173],
                    [1.02, 1.239],
                    [0.591, 0.92],
                    [0, 0],
                    [0.783, 2.703],
                    [-0.843, 3.007],
                    [-0.628, 0.784],
                    [0, 0],
                    [-1.167, 1.117],
                    [-2.563, 2.056],
                    [0, 0],
                    [-1.329, 2.915],
                    [-2.78, 2.036],
                    [-3.381, 0.06],
                    [-2.722, -1.8],
                    [0, 0],
                    [-4.029, -2.387],
                    [0, 0],
                    [-0.912, -0.938],
                    [-2.066, -2.556],
                    [-0.811, -2.873],
                    [0, 0],
                    [0.444, -1.026],
                    [0.883, -1.357],
                    [2.128, -2.435],
                    [1.45, -0.574],
                    [1.577, -0.106],
                    [1.603, 0.297],
                    [1.04, 0.367],
                    [0, 0],
                    [1.499, 0.745],
                    [0, 0],
                    [0, 0],
                    [0.835, 0.353],
                    [0, 0],
                    [0, 0],
                    [0.761, -0.468],
                    [0.762, -0.398],
                    [0, 0]
                  ],
                  "v": [
                    [7.974, -26.644],
                    [10.794, -27.772],
                    [15.513, -29.108],
                    [20.217, -29.473],
                    [24.655, -28.447],
                    [31.954, -22.656],
                    [34.849, -18.734],
                    [36.382, -15.87],
                    [37.146, -13.733],
                    [37.169, -5.426],
                    [32.594, 2.934],
                    [30.59, 5.2],
                    [29.159, 6.646],
                    [25.5, 9.853],
                    [17.326, 15.414],
                    [16.211, 18.918],
                    [10.392, 26.145],
                    [0.846, 29.353],
                    [-8.788, 26.533],
                    [-15.09, 19.03],
                    [-17.319, 15.313],
                    [-28.609, 6.912],
                    [-29.921, 5.612],
                    [-32.531, 2.705],
                    [-37.092, -5.739],
                    [-36.932, -14.444],
                    [-36.298, -16.164],
                    [-34.695, -19.143],
                    [-31.753, -23.048],
                    [-24.186, -28.653],
                    [-19.621, -29.681],
                    [-14.824, -29.409],
                    [-10.04, -28.13],
                    [-6.954, -26.884],
                    [-5.542, -26.03],
                    [-1.302, -23.447],
                    [-1.262, -23.419],
                    [-1.232, -23.406],
                    [1.411, -23.362],
                    [1.436, -23.372],
                    [1.473, -23.394],
                    [3.799, -24.729],
                    [6.139, -25.841]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            { "ty": "mm", "mm": 1, "nm": "Merge Paths 1", "mn": "ADBE Vector Filter - Merge", "hd": false },
            { "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 4 }, "o": { "a": 0, "k": 100, "ix": 5 }, "r": 1, "bm": 0, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill", "hd": false },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [374.994, 645.986], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 72,
      "st": -1,
      "bm": 0
    },
    {
      "ddd": 1,
      "ind": 4,
      "ty": 4,
      "nm": "LOGO_01 Outlines",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "rx": { "a": 0, "k": 0, "ix": 8 },
        "ry": {
          "a": 1,
          "k": [
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [360] },
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 15, "s": [720] },
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 36, "s": [720] },
            { "t": 52, "s": [1080] }
          ],
          "ix": 9
        },
        "rz": { "a": 0, "k": 0, "ix": 10 },
        "or": { "a": 0, "k": [0, 0, 0], "ix": 7 },
        "p": { "a": 0, "k": [80, 83.5, 0], "ix": 2 },
        "a": { "a": 0, "k": [375, 667, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-0.325, -2.058],
                    [1.509, 0.812],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [1.082, 6.502],
                    [-0.561, 3.27],
                    [-1.296, 2.573],
                    [-2.091, -2.17],
                    [0, 0],
                    [-0.775, -0.771],
                    [-1.529, -1.34],
                    [-1.274, -1.095],
                    [0.536, -1.383],
                    [0.332, -2.128]
                  ],
                  "o": [
                    [-0.089, 2.076],
                    [-1.491, -0.447],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-5.244, -3.778],
                    [-0.544, -3.263],
                    [0.467, -2.837],
                    [1.989, 2.261],
                    [0, 0],
                    [0.773, 0.773],
                    [1.481, 1.393],
                    [1.244, 1.126],
                    [-0.726, 1.285],
                    [-0.772, 2.007],
                    [0, 0]
                  ],
                  "v": [
                    [-30.591, 16.682],
                    [-30.242, 22.905],
                    [-34.744, 20.927],
                    [-37.017, 19.671],
                    [-38.047, 19.048],
                    [-39.041, 18.369],
                    [-48.706, 1.91],
                    [-48.66, -7.988],
                    [-45.993, -16.164],
                    [-39.88, -9.512],
                    [-37.258, -6.846],
                    [-34.941, -4.523],
                    [-30.48, -0.363],
                    [-26.701, 2.966],
                    [-28.595, 6.984],
                    [-30.247, 13.21]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-5.039, 2.361],
                    [-5.398, -1.212],
                    [0, 0],
                    [-1.068, -0.144],
                    [-1.655, 0.075],
                    [-0.537, 0.046],
                    [1.747, -2.212],
                    [6.607, -1.367],
                    [3.337, 0.45],
                    [2.987, 1.59],
                    [2.5, 6.342],
                    [-0.403, -0.027],
                    [-1.819, 0.267],
                    [-0.894, 0.179]
                  ],
                  "o": [
                    [5.427, -1.239],
                    [5.015, 2.318],
                    [0, 0],
                    [1.042, 0.207],
                    [1.509, 0.206],
                    [0.535, -0.028],
                    [-1.021, 2.642],
                    [-4.212, 5.357],
                    [-3.296, 0.693],
                    [-3.339, -0.473],
                    [-5.948, -3.135],
                    [0.404, 0.033],
                    [1.986, 0.128],
                    [0.907, -0.146],
                    [0, 0]
                  ],
                  "v": [
                    [-15.416, 26.628],
                    [0.262, 21.194],
                    [15.884, 26.516],
                    [17.584, 26.872],
                    [20.742, 27.414],
                    [25.424, 27.693],
                    [27.032, 27.58],
                    [22.865, 34.923],
                    [5.926, 45.382],
                    [-4.143, 45.695],
                    [-13.726, 42.569],
                    [-27.012, 27.803],
                    [-25.802, 27.894],
                    [-20.094, 27.547],
                    [-17.393, 27.06]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [1.932, 2.268],
                    [-6.108, 2.35],
                    [-3.369, 0.03],
                    [-3.113, -1.306],
                    [-1.39, -0.973],
                    [-1.515, -1.128],
                    [1.439, -1.38],
                    [0, 0],
                    [0.454, -0.455],
                    [2.489, -2.561],
                    [2.153, -2.861],
                    [0.793, -1.269],
                    [1.17, 1.043],
                    [2.359, 2.38]
                  ],
                  "o": [
                    [-2.036, -2.172],
                    [3.271, -5.584],
                    [3.136, -1.216],
                    [3.368, -0.019],
                    [1.554, 0.655],
                    [1.57, 1.089],
                    [-1.539, 1.286],
                    [0, 0],
                    [-0.459, 0.451],
                    [-2.472, 2.546],
                    [-2.473, 2.558],
                    [-0.895, 1.189],
                    [-1.214, -0.988],
                    [-2.516, -2.209],
                    [0, 0]
                  ],
                  "v": [
                    [-39.12, -11.174],
                    [-45.078, -17.832],
                    [-30.447, -30.221],
                    [-20.586, -32.143],
                    [-10.733, -30.214],
                    [-6.288, -27.786],
                    [-1.61, -24.472],
                    [-6.068, -20.462],
                    [-7.281, -19.286],
                    [-8.653, -17.928],
                    [-16.166, -10.406],
                    [-23.18, -2.331],
                    [-25.72, 1.354],
                    [-29.304, -1.683],
                    [-36.624, -8.568]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 3,
              "ty": "sh",
              "ix": 4,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [1.509, 0.101],
                    [0.914, 0.144],
                    [0.059, 1.8],
                    [0, 0],
                    [-0.828, 2.274],
                    [-0.641, 1.166],
                    [-1.537, -1.192],
                    [-3.448, -2.215],
                    [-0.887, -0.526],
                    [0, 0],
                    [0.026, -0.324],
                    [2.065, -0.565],
                    [2.362, -0.432]
                  ],
                  "o": [
                    [-1.638, 0.19],
                    [-0.96, -0.066],
                    [-0.384, -1.754],
                    [0, 0],
                    [0.229, -2.405],
                    [0.468, -1.24],
                    [1.484, 1.254],
                    [3.212, 2.507],
                    [0.864, 0.551],
                    [0, 0],
                    [-0.026, 0.325],
                    [-2.007, 0.732],
                    [-2.335, 0.64],
                    [0, 0]
                  ],
                  "v": [
                    [-20.799, 23.405],
                    [-25.542, 23.613],
                    [-28.379, 23.307],
                    [-29.047, 17.963],
                    [-28.936, 14.51],
                    [-27.341, 7.452],
                    [-25.679, 3.842],
                    [-21.153, 7.517],
                    [-11.198, 14.65],
                    [-8.576, 16.27],
                    [-4.414, 18.632],
                    [-4.47, 19.33],
                    [-10.584, 21.277],
                    [-17.644, 22.911]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 4",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 4,
              "ty": "sh",
              "ix": 5,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-1.539, 1.222],
                    [-1.558, -1.396],
                    [0, 0],
                    [-0.089, -0.082],
                    [-2.53, -2.445],
                    [-2.22, -2.708],
                    [-0.947, -1.459],
                    [-0.174, -0.276],
                    [1.606, -1.174],
                    [3.437, -2.019],
                    [0.871, -0.47],
                    [0, 0],
                    [0, 0],
                    [1.466, 0.752],
                    [0, 0],
                    [0.863, 0.501],
                    [3.239, 2.374],
                    [1.574, 1.255],
                    [-0.917, 1.201],
                    [-2.471, 2.505],
                    [-2.518, 2.475],
                    [-0.567, 0.534]
                  ],
                  "o": [
                    [1.457, -1.337],
                    [1.637, 1.283],
                    [0, 0],
                    [0.089, 0.082],
                    [2.567, 2.386],
                    [2.51, 2.469],
                    [1.107, 1.354],
                    [0.183, 0.272],
                    [-1.556, 1.244],
                    [-3.23, 2.376],
                    [-0.862, 0.499],
                    [0, 0],
                    [0, 0],
                    [-1.456, -0.74],
                    [0, 0],
                    [-0.873, -0.472],
                    [-3.441, -2.029],
                    [-1.617, -1.193],
                    [0.788, -1.281],
                    [2.134, -2.776],
                    [2.477, -2.485],
                    [0.561, -0.543],
                    [0, 0]
                  ],
                  "v": [
                    [-4.681, -19.529],
                    [-0.196, -23.381],
                    [4.591, -19.352],
                    [5.813, -18.243],
                    [6.082, -18],
                    [13.727, -10.664],
                    [20.883, -2.943],
                    [23.999, 1.262],
                    [24.531, 2.087],
                    [19.783, 5.712],
                    [9.762, 12.312],
                    [7.163, 13.771],
                    [4.505, 15.135],
                    [-0.198, 17.573],
                    [-4.607, 15.305],
                    [-7.262, 13.939],
                    [-9.865, 12.475],
                    [-19.9, 5.859],
                    [-24.693, 2.194],
                    [-22.132, -1.533],
                    [-15.149, -9.41],
                    [-7.56, -16.819],
                    [-5.868, -18.433]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 5",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 5,
              "ty": "sh",
              "ix": 6,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0.451, -1.986],
                    [1.036, -0.061],
                    [1.375, 0.148],
                    [0.487, 0.07],
                    [0, 0],
                    [4.303, 1.619],
                    [0, 0],
                    [0, 0],
                    [-0.865, 0.552],
                    [-3.221, 2.505],
                    [-1.454, 1.223],
                    [-0.268, -0.577],
                    [-0.313, -2.916]
                  ],
                  "o": [
                    [-0.022, 2.042],
                    [-0.991, 0.151],
                    [-1.253, 0.065],
                    [-0.485, -0.052],
                    [0, 0],
                    [-4.488, -0.895],
                    [0, 0],
                    [0, 0],
                    [0.888, -0.528],
                    [3.451, -2.225],
                    [1.498, -1.173],
                    [0.303, 0.564],
                    [1.215, 2.667],
                    [0, 0]
                  ],
                  "v": [
                    [28.986, 17.467],
                    [28.273, 23.53],
                    [25.222, 23.853],
                    [21.204, 23.664],
                    [19.743, 23.47],
                    [17, 23.012],
                    [3.739, 19.254],
                    [5.989, 17.964],
                    [8.668, 16.441],
                    [11.295, 14.816],
                    [21.264, 7.669],
                    [25.685, 4.069],
                    [26.547, 5.779],
                    [28.832, 14.244]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 6",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 6,
              "ty": "sh",
              "ix": 7,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-2.219, 2.493],
                    [-0.132, -4.258],
                    [2.796, -4.628],
                    [2.087, -1.667],
                    [1.229, -0.7],
                    [1.232, -0.574],
                    [0.888, -0.262],
                    [0.153, 2.344],
                    [0, 0],
                    [1.115, 2.433],
                    [0.376, 0.682],
                    [-3.211, 3.18]
                  ],
                  "o": [
                    [2.319, -2.407],
                    [1.896, 3.831],
                    [0.174, 5.482],
                    [-1.415, 2.3],
                    [-1.044, 0.864],
                    [-1.255, 0.7],
                    [-0.89, 0.414],
                    [0.393, -2.32],
                    [0, 0],
                    [-0.441, -2.637],
                    [-0.327, -0.714],
                    [3.437, -2.941],
                    [0, 0]
                  ],
                  "v": [
                    [39.439, -8.746],
                    [46.228, -16.111],
                    [49.287, -3.78],
                    [45.283, 11.853],
                    [40.016, 17.891],
                    [36.656, 20.122],
                    [32.944, 22.083],
                    [30.262, 23.126],
                    [30.63, 16.103],
                    [30.263, 12.798],
                    [27.921, 5.152],
                    [26.859, 3.062],
                    [36.82, -6.136]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 7",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 7,
              "ty": "sh",
              "ix": 8,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0.814, -0.79],
                    [1.528, -1.305],
                    [1.172, -0.961],
                    [1.277, 1.616],
                    [2.505, 2.525],
                    [0, 0],
                    [1.177, 1.142],
                    [0, 0],
                    [1.622, 1.346],
                    [-0.905, 0.614],
                    [0, 0],
                    [-0.618, 0.335],
                    [-2.733, 0.532],
                    [-5.072, -2.26],
                    [-3.065, -4.584],
                    [-0.231, -0.381],
                    [2.259, -2.378]
                  ],
                  "o": [
                    [-0.801, 0.804],
                    [-1.482, 1.358],
                    [-1.132, 1.009],
                    [-1.112, -1.753],
                    [-2.235, -2.797],
                    [0, 0],
                    [-1.152, -1.156],
                    [0, 0],
                    [-1.526, -1.438],
                    [0.867, -0.636],
                    [0, 0],
                    [0.597, -0.384],
                    [2.406, -1.426],
                    [5.473, -1.078],
                    [5.086, 2.25],
                    [0.249, 0.37],
                    [-2.112, 2.514],
                    [0, 0]
                  ],
                  "v": [
                    [36.055, -8.272],
                    [33.633, -5.88],
                    [29.173, -1.826],
                    [25.708, 1.122],
                    [22.082, -3.912],
                    [14.908, -11.85],
                    [11.137, -15.591],
                    [7.649, -19.046],
                    [6.204, -20.426],
                    [1.492, -24.617],
                    [4.149, -26.491],
                    [5.955, -27.735],
                    [7.726, -28.87],
                    [15.51, -31.823],
                    [31.825, -29.836],
                    [44.393, -19.301],
                    [45.097, -18.167],
                    [38.534, -10.829]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 8",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 8,
              "ty": "sh",
              "ix": 9,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0.874, -1.781],
                    [1.007, -1.734],
                    [2.27, -3.32],
                    [2.087, -2.603],
                    [0.079, 0.112],
                    [5.612, 2.307],
                    [5.926, -1.337],
                    [2.553, -1.61],
                    [0.613, -0.419],
                    [0, 0],
                    [1, -0.776],
                    [0.266, 0.205],
                    [1.434, 1.056],
                    [1.684, 0.769],
                    [3.711, 0.089],
                    [3.499, -1.238],
                    [3.869, -5.687],
                    [1.867, 2.716],
                    [1.936, 3.526],
                    [0.867, 1.808],
                    [0.636, 1.79],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-2.602, -3.134],
                    [-2.303, -2.664],
                    [-1.102, -7.421],
                    [-1.879, -3.323],
                    [-3.117, -2.295],
                    [0, 0],
                    [0, 0],
                    [-0.814, -0.43],
                    [-1.919, -0.572],
                    [-0.783, -0.122],
                    [-0.093, -0.262],
                    [-6.469, -3.599],
                    [-7.244, 1.564],
                    [-3.106, 1.995],
                    [-2.185, 2.956],
                    [-1.015, 3.214],
                    [-0.264, 0.05],
                    [-1.415, 0.64],
                    [-1.274, 0.731],
                    [-1.19, 1.004],
                    [-1.611, 2.663],
                    [0.275, 6.124],
                    [2.602, 4.478],
                    [-2.316, 2.793],
                    [-2.543, 3.216],
                    [-1.235, 1.651],
                    [-1.306, 1.759]
                  ],
                  "o": [
                    [-0.673, 1.769],
                    [-0.906, 1.782],
                    [-1.972, 3.498],
                    [-1.892, 2.747],
                    [-0.078, -0.112],
                    [-3.537, -4.996],
                    [-5.601, -2.314],
                    [-2.957, 0.662],
                    [-0.651, 0.378],
                    [0, 0],
                    [-1.005, 0.73],
                    [-0.263, -0.208],
                    [-1.427, -1.089],
                    [-1.479, -1.103],
                    [-3.372, -1.535],
                    [-3.714, -0.078],
                    [-6.427, 2.265],
                    [-2.064, -2.569],
                    [-2.28, -3.316],
                    [-0.985, -1.75],
                    [-0.858, -1.793],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [2.578, 3.188],
                    [2.237, 2.729],
                    [-3.864, 6.41],
                    [0.558, 3.728],
                    [1.867, 3.322],
                    [0, 0],
                    [0, 0],
                    [0.772, 0.441],
                    [1.626, 0.857],
                    [0.827, 0.239],
                    [0.086, 0.264],
                    [2.421, 6.895],
                    [6.431, 3.68],
                    [3.627, -0.771],
                    [3.095, -2.021],
                    [2.013, -2.731],
                    [0.26, -0.042],
                    [1.658, -0.326],
                    [1.407, -0.646],
                    [1.293, -0.745],
                    [2.446, -1.983],
                    [3.212, -5.353],
                    [-0.224, -5.19],
                    [2.379, -2.731],
                    [2.613, -3.131],
                    [1.246, -1.625],
                    [1.273, -1.646],
                    [0, 0]
                  ],
                  "v": [
                    [64.89, -49.672],
                    [62.463, -44.269],
                    [59.625, -38.97],
                    [53.204, -28.772],
                    [47.221, -20.753],
                    [46.996, -21.095],
                    [32.885, -32.318],
                    [15.053, -33.994],
                    [6.698, -30.559],
                    [4.833, -29.29],
                    [3.081, -28.01],
                    [0.058, -25.768],
                    [-0.728, -26.396],
                    [-5.005, -29.589],
                    [-9.782, -32.386],
                    [-20.562, -34.831],
                    [-31.491, -33.037],
                    [-47.479, -20.714],
                    [-53.4, -28.626],
                    [-59.773, -38.871],
                    [-62.553, -44.214],
                    [-64.891, -49.672],
                    [-70.834, -46.414],
                    [-66.942, -41.462],
                    [-63.106, -36.63],
                    [-55.364, -27.136],
                    [-48.533, -19.065],
                    [-52.752, 2.542],
                    [-49.13, 13.257],
                    [-41.595, 21.864],
                    [-40.404, 22.691],
                    [-39.168, 23.451],
                    [-36.8, 24.775],
                    [-31.533, 27.034],
                    [-29.127, 27.549],
                    [-28.866, 28.341],
                    [-14.989, 44.872],
                    [6.504, 48.109],
                    [16.699, 43.869],
                    [24.694, 36.314],
                    [29.252, 27.31],
                    [30.035, 27.178],
                    [34.585, 25.632],
                    [38.588, 23.533],
                    [42.463, 20.913],
                    [48.559, 13.832],
                    [52.866, -3.918],
                    [48.517, -18.701],
                    [55.557, -26.988],
                    [63.253, -36.531],
                    [67.031, -41.405],
                    [70.834, -46.414]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 9",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            { "ty": "mm", "mm": 1, "nm": "Merge Paths 1", "mn": "ADBE Vector Filter - Merge", "hd": false },
            { "ty": "fl", "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 4 }, "o": { "a": 0, "k": 100, "ix": 5 }, "r": 1, "bm": 0, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill", "hd": false },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [375, 638.706], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 11,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 72,
      "st": -1,
      "bm": 0
    },
    {
      "ddd": 1,
      "ind": 5,
      "ty": 3,
      "nm": "LOGO_01",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "rx": { "a": 0, "k": 0, "ix": 8 },
        "ry": {
          "a": 1,
          "k": [
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 0, "s": [360] },
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 15, "s": [720] },
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 36, "s": [720] },
            { "t": 52, "s": [1080] }
          ],
          "ix": 9
        },
        "rz": { "a": 0, "k": 0, "ix": 10 },
        "or": { "a": 0, "k": [0, 0, 0], "ix": 7 },
        "p": { "a": 0, "k": [80, 83.5, 0], "ix": 2 },
        "a": { "a": 0, "k": [375, 667, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "ip": 71,
      "op": 72,
      "st": -1,
      "bm": 0
    }
  ],
  "markers": []
}
